/**
 * The chevron a one-line disclosure turns (T13e-2b), drawn by the stylesheet: a reference page has hundreds of
 * them, and an inline icon would carry its path into the page each time.
 */
export function Chev() {
  return <span className="ic chev" aria-hidden="true" />;
}
